import { Contact, ContactTypeToReset, ContactType } from 'typings'
import { ContactsToResetResponse } from 'typings/account'

export const mapFromResetContacts = (contactsToReset: ContactsToResetResponse) => {
    const contacts: Contact[] = contactsToReset.reduce((acc, currentValue) => {
        const { id, contact } = currentValue

        if (currentValue.type === ContactTypeToReset.CELULAR) {
            return [
                {
                    id,
                    value: contact,
                    type: ContactType.SMS,
                    contactType: ContactType.MOBILE,
                },
                ...acc,
            ]
        }

        return [
            ...acc,
            {
                id,
                value: contact,
                type: ContactType.EMAIL,
            },
        ]
    }, [])

    return contacts
}
